import 'core-js/es6/promise';
import 'core-js/es6/object';
import 'core-js/es7/object';
import 'core-js/es6/array';
import 'core-js/es7/array';
import 'core-js/es6/string';

import Vue from 'vue';
import Vuex from 'vuex';
import Router from 'vue-router';
import BootstrapVue from 'bootstrap-vue';
import Axios from 'axios'
import { sync } from 'vuex-router-sync';
import VueSweetAlert from 'vue-sweetalert';
import VueCookies from 'vue-cookies';
import Vuetable from 'vuetable-2';

import App from './components/App';
import VuexStore from './vuex/store';
import routes from './router-config';

import i18n from 'voo-i18n';
import translations from './languages/map';

import Echo from 'laravel-echo';
window.Pusher = require('pusher-js');

import BootstrapVueIcons from 'bootstrap-vue'

Vue.use(i18n, translations)
Vue.use(Vuex);
Vue.use(Router);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueSweetAlert);
Vue.use(VueCookies);
Vue.use(Vuetable);

Vue.directive("scroll", {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener("scroll", f);
      }
    };
    window.addEventListener("scroll", f);
  },
});

Vue.prototype.$http = Axios;

const store = new Vuex.Store(VuexStore);

const router = new Router({
  routes,
  mode: 'history',
});

sync(store, router);

Vue.config.productionTip = false;

Axios.interceptors.request.use(
  config => {
    if (store.getters.getUserObject.token) {
      config.headers.common['Authorization'] = `Bearer ${store.getters.getUserObject.token}`
    }
    return config;
  },
  error => {

    return Promise.reject(error);
  }
)

/* eslint-disable no-new */
new Vue({
  store,
  el: '#app',
  template: '<App/>',
  components: { App },
  router,
}).$mount('#app');


window.Echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.MIX_PUSHER_APP_KEY,
  wsHost: process.env.MIX_PUSHER_APP_HOST,
  wsPort: 81,
  wssPort: 81,
  forceTLS: false,
  disableStats: true,
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js